import React from 'react'
import { useTrans } from 'hooks'
import { PaginaNode, useInteresseUtenteQuery } from '@gql/graphql'
import {
  LandingNewsletterAdvForm,
  LandingNewsletterGiardinaggioMiniguidaForm,
  LandingNewsletterHead,
  LandingNewsletterHeader,
  Page,
} from 'components/organisms'
import styles from './LandingNewsletterTemplate.module.sass'
import { JsonLd } from '@components/atoms'

interface Props {
  pagina?: PaginaNode
}

const LandingNewsletterTemplate = (props: Props) => {
  const { pagina = undefined } = props

  const { data } = useInteresseUtenteQuery()

  const t = useTrans()

  return (
    <Page pagina={pagina} headerVersion="none" footerVersion="none" className={`${styles.root}`}>
      <LandingNewsletterHeader />
      <main>
        <LandingNewsletterHead pagina={pagina} />
        {pagina.chiave === 'landing-newsletter-adv' && <LandingNewsletterAdvForm />}
        {pagina.chiave === 'landing-newsletter-giardinaggio-miniguida' && (
          <LandingNewsletterGiardinaggioMiniguidaForm interessiUtente={data?.interessiUtente} />
        )}
      </main>
      <JsonLd type="organization" />
    </Page>
  )
}

export default LandingNewsletterTemplate
